import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Media from 'react-responsive';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import InlineSVG from 'react-svg-inline';
import _ from 'lodash';
import stylesTable from '../../SearchResults/elements/ProductTableStyle.scss';
import styles from '../ToCartPopup.scss';
import TableItemQuantity from '../../CartPage/elements/tableElements/TableItemQuantity';
import cx from 'classnames';
import { Link } from 'react-router';


export default class ToCartTable extends Component {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const {foundDetail, foundDetailOffers, chosenOfferId, toCartQuantity, changeToCartItemQuantity} = this.props;

    let chosenOffer = foundDetailOffers.filter(offer => +offer.offerId == +chosenOfferId);

    const tableRows = _.map(chosenOffer, ({
      description,
      price
    }) => (
      <Tr>
        <Td column="Наименование">
          <div>{foundDetail.name} <Link className="link" to={`/results?detailNum=${foundDetail.detailNum}`}>{foundDetail.detailNum}</Link></div>
        </Td>
        <Td column="Описание">
          {description}
        </Td>
        <Td column="Кол-во, шт.">
          <TableItemQuantity
            quantity={toCartQuantity}
            onChange={changeToCartItemQuantity}
            />
        </Td>
        <Td column="Цена &#8381;">
          <strong>{price}</strong>
        </Td>
      </Tr>
    ));

    return (
      <div>
        <Table className={cx([stylesTable.table, stylesTable.tableHeaderUnderline])} style={{width:'100%'}}>
          {tableRows}
        </Table>

      </div>
    );
  }
}

ToCartTable.propTypes = {
  toCartPopupActions: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/components/ToCartPopup/elements/ToCartTable.jsx
 **/